import { useEffect, useState } from "react"
import { getRandomIntInclusive } from "../utils/random"
import { usePluginConfig } from "../contexts/pluginContext"

export const useRandomAsset = (assetType) => {
  const pluginConfig = usePluginConfig();
  const [promotionalAsset, updatePromotionalAsset] = useState();
  const publisherSettings = pluginConfig.publisherSettings;
  const promotionalAssets = publisherSettings.publisher.promotional_assets || [];
  const eventListingAds = promotionalAssets.filter(
    (asset) => asset.asset_unit === assetType
  );

  useEffect(() => {
    const selectRandomAsset = () => {
      return eventListingAds[getRandomIntInclusive(0, eventListingAds.length - 1)];
    };

    updatePromotionalAsset(selectRandomAsset());
  }, []);

  if (!promotionalAsset) {
    return null;
  }

  return promotionalAsset;
}
